import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "source", "icon" ]

  toggle() {
    if (this.sourceTarget.type === 'password') {
      this.sourceTarget.type = 'text';
      this.iconTarget.classList.remove('fa-eye');
      this.iconTarget.classList.add('fa-eye-slash');
    } else {
      this.sourceTarget.type = 'password';
      this.iconTarget.classList.remove('fa-eye-slash');
      this.iconTarget.classList.add('fa-eye');
    }
  }
}